import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import FormItem from './FormItem';

import { lang } from '../../redux/lang/selectors';

const selector = createStructuredSelector({
  selectedLang: lang,
});

export default connect(selector)(FormItem);
